import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LookupOrganization } from '@dialogue/scribe'

import { EligibilitySearchState } from './types'

const initialState: EligibilitySearchState = {
  results: null,
  loading: false,
  error: null,
  enrolWithOrganizationIdLoading: false,
  enrolWithOrganizationIdSuccess: false,
  enrolWithOrganizationIdError: null,
  accessVerificationLoading: true,
  accessVerificationError: null,
}

const { actions, reducer } = createSlice({
  name: 'eligibilitySearch',
  initialState,
  reducers: {
    searchOrganizations: (state, action: PayloadAction<string>) => {
      state.loading = true
      state.error = null
      void action
    },

    searchOrganizationsSuccess: (state, action: PayloadAction<LookupOrganization[]>) => {
      state.loading = false
      state.results = action.payload
    },

    searchOrganizationsFailure: (state, action: PayloadAction<{ error: unknown }>) => {
      state.loading = false
      state.error = action.payload.error
    },

    enrolWithOrganizationId: (state, action: PayloadAction<number>) => {
      state.enrolWithOrganizationIdLoading = true
      state.enrolWithOrganizationIdSuccess = false
      state.enrolWithOrganizationIdError = null
      void action
    },

    enrolWithOrganizationIdSuccess: (state) => {
      state.enrolWithOrganizationIdLoading = false
      state.enrolWithOrganizationIdSuccess = true
    },

    enrolWithOrganizationIdFailure: (state, action: PayloadAction<{ error: unknown }>) => {
      state.enrolWithOrganizationIdLoading = false
      state.enrolWithOrganizationIdSuccess = false
      state.enrolWithOrganizationIdError = action.payload.error
    },

    checkEligibilityAccess: (state) => {
      state.accessVerificationLoading = true
      state.accessVerificationError = null
    },

    checkEligibilityAccessSuccess: (state) => {
      state.accessVerificationLoading = false
    },

    checkEligibilityAccessFailure: (state, action: PayloadAction<{ error: unknown }>) => {
      state.accessVerificationLoading = false
      state.accessVerificationError = action.payload.error
    },

    reset: () => initialState,
  },
})

export { actions as eligibilitySearchActions, initialState }

export default reducer
